import React, { useState, useEffect } from 'react';
import camera from '../components/Camera';
import Button from 'react-bootstrap/Button';

const Snapshot = (props) => {
    const [cameraStatus, setCameraStatus] = useState(false);
    const [timer, setTimer] = useState(0);

    const initializeCamera = () => {
        camera.startCamera();
        setCameraStatus(true);
        setTimer(5);
    };

    const captureSnapshot = () => {
        if (cameraStatus === false){
            camera.startCamera();
            setCameraStatus(true);
        }
        camera.takeSnapshot("cognitive load status", function(result){
            console.log("Status: " + result);
            if (result === 'happy') {
                props.setCogLoad('vvl');
            } else if (result === 'tired') {
                props.setCogLoad('vvh');
            }
        });
    }

    useEffect(() => {
        if (cameraStatus !== false) {

            if (!(timer > 0)) {
                captureSnapshot();
                setTimer(5);
            }

            timer > 0 &&  setTimeout(() => setTimer(timer - 1), 1000);
        }
    }, [timer]);

    return (
        <div>
            <h3>Camera status: {String(cameraStatus)}</h3>
            <Button bsStyle="primary" onClick={initializeCamera}>Start Camera</Button>
            <Button bsStyle="primary" onClick={captureSnapshot}>Take Picture</Button>
        </div>
    );

}

export default Snapshot